'use client';

import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { MdOutlineCalendarMonth, MdOutlineKeyboardDoubleArrowRight, MdVerified } from "react-icons/md";
import { StyledWrapper } from '@/components/Styled'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FaAngleDown, FaXTwitter } from 'react-icons/fa6';
import { IoArrowDown } from 'react-icons/io5';
import Image from 'next/image';
import { motion, AnimatePresence } from "framer-motion"
import { CiClock2 } from 'react-icons/ci';
import Button from '@/components/CommonComponent/button';
import { FaUserCircle } from "react-icons/fa";
import Faq1 from "@/components/Home/faqComp";

const Blogs = ({ apidata, blogs  }: any) => {
    // console.log("slug",slug);

    const [path_name, setPathName] = useState('');
    const [headings, setHeadings] = useState<any>([]);
    const [isExpanded, setIsExpanded] = useState(false)
    const pathname = usePathname(); 
    const [isOpen, setIsOpen] = useState(true);
    const [showrecentblogs, setshowrecentblogs] = useState(false)
    const [expandedTitle, setExpandedTitle] = useState<number | null>(null)
    const [expandedSummary, setExpandedSummary] = useState<number | null>(null)
    const [blogBannerStyle, setBlogBannerStyle] = useState({});
    const [showcategory, setshowcategory] = useState(false)
    const toggleVisibility = () => {
        setIsOpen(!isOpen);
    };
    const toggleVisibilityrecent = () => {
        setshowrecentblogs(!showrecentblogs);
    };
    const toggleVisibilitycategory = () => {
        setshowcategory(!showcategory);
    };
    const segments = pathname!.replace(/\/$/, '').split('/');
    const lastsegment = segments.pop();
    const [parsedBody, setParsedBody] = useState<string | null>(null);

    useEffect(() => {
        setPathName(window.location.href);
    }, []);
    useEffect(() => {
        if (apidata?.body) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(apidata.body, 'text/html');
            const headingElements = doc.querySelectorAll('h2, h3');
            const extractedHeadings = Array.from(headingElements)
                .map((heading: any) => {
                    let text = heading.innerText.trim();
                    if (!text) return null;
                    const slug = text
                        .toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/[^\w-]+/g, '')
                        .replace(/^-+|-+$/g, '');
                    if (!slug) return null;
                    heading.id = slug;
                    heading.classList.add(slug);
                    return { id: slug, text, tag: heading.tagName };
                })
                .filter(Boolean);
                setHeadings(extractedHeadings);
            setParsedBody(doc.body.innerHTML);
        }
    }, [apidata.body]);

    const scrollToSection = (targetId: string) => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    function truncateText(text: string, limit: number) {
        if (text?.length > limit) {
            return text.substring(0, limit) + '...'
        }
        return text
    }
    useEffect(() => {
        const images = [
            '/blog/blog-inner-bg1.svg',
            '/blog/blog-inner-bg2.svg',
            '/blog/blog-inner-bg3.svg',
            '/blog/blog-inner-bg4.svg',
            '/blog/blog-inner-bg5.svg',
        ];

        // Select a random image
        const randomImage = images[Math.floor(Math.random() * images.length)];

        // Set background image dynamically
        setBlogBannerStyle({
            backgroundImage: `url(${randomImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        });
    }, []);
    return (
        <div>
            {
                <div className='w-full '>
                    <div className='mb-8'>
                        <div
                            className="w-full h-[430px]  hidden bg-image md:block px-6"
                            style={blogBannerStyle} // Apply the dynamically set style
                        >
                        </div>
                        <div className=' md:-mt-[45vh] xl:-mt-[300px] md:w-[70%] lg:w-[70%] rounded-2xl shadow h-fit xl:w-fit mx-auto '>
                            <Image src={apidata?.image} alt={apidata?.image_alt} height={381} width={970} 
                            unoptimized
                            className='mx-auto 3xl:w-auto  rounded-2xl max-h-[382px] 3xl:h-full border-blue'></Image>
                        </div>
                    </div>
                    <div className=' py-5'>
                        <div className='w-full  flex lg:gap-0 xl:gap-3 2xlgap-10 flex-col-reverse  lg:flex-row lg:flex-nowrap 2xl:ml-20 flex-wrap xl:w-[95%]
                        2xl:w-[80%]  px-4 text-white mb-8 lg:mb-32 '>
                            <aside>
                                <div className='xl:min-w-[314px] w-full lg:w-[314px]  h-fit  sticky top-20 flex flex-col gap-6'>
                                    <div className=" leading-tight w-full px-4 rounded-lg text-textGrey text-[18px] ">
                                        <div className="flex justify-between items-center w-full  text-black">
                                            <p className="text-[20px] border-b-2 border-pink pb-1 text-homeblack font-medium mb-4">Table of Contents</p>
                                            <div className='h-[30px] w-[30px] flex justify-center items-center  bg-homegrey text-white  rounded-full'>
                                                <IoArrowDown
                                                    className={`text-[20px] duration-200 cursor-pointer ${isOpen ? 'rotate-180' : ''}`}
                                                    onClick={toggleVisibility}
                                                />
                                            </div>
                                        </div>
                                        <AnimatePresence>
                                            {isOpen && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: 'auto', opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className='max-h-[90vh] overflow-y-auto lg:border-r-[2px] border-grey'
                                                >
                                                    <motion.ul
                                                        className="flex flex-col  gap-3 list-disc px-5"
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                    >
                                                        {headings.map((heading: any, index: number) => (
                                                            <motion.a
                                                                key={heading.id}
                                                                href={`#${heading.id}`}
                                                                className={`pl-${heading.tag === "H3" ? 4 : 3} hover:text-blue cursor-pointer`}
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ delay: index * 0.2, duration: 0.3 }}
                                                            >
                                                                {heading.text}
                                                            </motion.a>
                                                        ))}
                                                    </motion.ul>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                    <div className="leading-tight px-4 rounded-lg text-textGrey text-[18px]">
                                        <div className="flex justify-between items-center w-full text-homeblack">
                                            <p className="text-[20px] border-b-2 border-pink pb-1 font-medium mb-4">Recent Posts</p>
                                            <div className='h-[30px] w-[30px] flex justify-center items-center  bg-homegrey text-white  rounded-full'>
                                                <IoArrowDown
                                                    className={`text-[20px] duration-200 cursor-pointer ${showrecentblogs ? 'rotate-180' : ''}`}
                                                    onClick={toggleVisibilityrecent}
                                                />
                                            </div>
                                        </div>
                                        <AnimatePresence>
                                            {showrecentblogs && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: 'auto', opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className='max-h-[90vh] overflow-y-auto'
                                                >
                                                    <motion.ul
                                                        className="flex flex-col gap-3 list-disc  px-5"
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                    >
                                                        {blogs?.results?.recent_blogs?.map((elem: any, index: number) => (
                                                            <motion.li
                                                                key={elem?.slug_link}
                                                                className="cursor-pointer  hover:text-blue"
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ delay: index * 0.2, duration: 0.3 }} // Delay based on index for sequential appearance
                                                            >
                                                                <Link href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}>
                                                                    {elem?.title}
                                                                </Link>
                                                            </motion.li>
                                                        ))}
                                                    </motion.ul>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                    <div className="leading-tight px-4 h-fit rounded-lg text-textGrey text-[18px] ">
                                        <div className="flex justify-between items-center w-full  text-homeblack">
                                            <p className=" border-b-2 border-pink pb-1 font-medium mb-4">Categories</p>
                                            <div className='h-[30px] w-[30px] flex justify-center items-center  bg-homegrey text-white  rounded-full'>
                                                <IoArrowDown
                                                    className={`text-[20px] duration-200 cursor-pointer ${showcategory ? 'rotate-180' : ''}`}
                                                    onClick={toggleVisibilitycategory}
                                                />
                                            </div>
                                        </div>
                                        <AnimatePresence>
                                            {showcategory && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: 'auto', opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className=' overflow-y-auto'
                                                >
                                                    <motion.ul
                                                        className="flex flex-col gap-3 list-disc  px-5"
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                    >
                                                        {blogs?.results?.category?.map((elem: any, index: number) => (
                                                            <motion.li
                                                                key={elem?.slug_link}
                                                                className="cursor-pointer hover:text-blue"
                                                                initial={{ opacity: 0 }}
                                                                animate={{ opacity: 1 }}
                                                                exit={{ opacity: 0 }}
                                                                transition={{ delay: index * 0.2, duration: 0.3 }} // Delay based on index for sequential appearance
                                                            >
                                                                <Link href={`/blog/${elem?.category_slug}`} key={elem.name}>
                                                                    <li className='hover:text-pink cursor-pointer'> {elem?.name}</li>
                                                                </Link>
                                                            </motion.li>
                                                        ))}
                                                    </motion.ul>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                    <div className=" mx-4  ">
                                        <p className="text-xl font-semibold text-homeblack mb-4">Share this post:</p>
                                        <div className="flex space-x-2">
                                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(path_name)}`} target="_blank" rel="noopener noreferrer">
                                                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1877F2] text-white smooth hover:bg-[#1656A1] hover:-translate-y-1 transition-colors duration-300">
                                                    <FaFacebookF className="text-xl" />
                                                </button>
                                            </a>
                                            <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(path_name)}&text=Check%20this%20out!`} target="_blank" rel="noopener noreferrer">
                                                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-[#000] text-white smooth hover:bg-[#000] hover:-translate-y-1 transition-colors duration-300">
                                                    <FaXTwitter className="text-xl" />
                                                </button>
                                            </a>
                                            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(path_name)}`} target="_blank" rel="noopener noreferrer">
                                                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-[#0077B5] text-white smooth hover:bg-[#005582] hover:-translate-y-1 transition-colors duration-300">
                                                    <FaLinkedinIn className="text-xl" />
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                            <div className=' w-full lg:w-full  flex flex-col gap-10 text-black '>
                                {/* <div class="table-container"> add this class in a div before adding table for every blog body */}
                                <StyledWrapper>
                                    <div className='bg-white rounded-lg p-4 md:px-8'>
                                        {apidata ? (
                                            <div>
                                                <div>
                                                    <div className=" w-full leading-tight rounded-lg text-textGrey text-[18px] ">
                                                        <div className="text-[16px]  flex items-center justify-start gap-2 flex-wrap">
                                                            <span className="text-blue">
                                                                <Link href="/">Home</Link>
                                                            </span>
                                                            <span>
                                                                <MdOutlineKeyboardDoubleArrowRight />
                                                            </span>
                                                            <span className=" max-w-[150px] text-blue sm:max-w-[200px] lg:max-w-[250px]">
                                                                <Link href="/blog/">Blog</Link>
                                                            </span>
                                                            <span>
                                                                <MdOutlineKeyboardDoubleArrowRight />
                                                            </span>
                                                            <span className="truncate max-w-[150px] sm:max-w-[200px] lg:max-w-[250px] text-blue">
                                                                <Link href={`/blog/${apidata?.category_slug}`}>
                                                                    {apidata?.category}
                                                                </Link>
                                                            </span>
                                                            <span>
                                                                <MdOutlineKeyboardDoubleArrowRight />
                                                            </span>
                                                            <span className="text-[16px] truncate max-w-[150px] sm:max-w-[200px] lg:max-w-[250px]">
                                                                {apidata?.title}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <h1 className='text-[28px] text-left mt-4 text-homeblack font-bold md:text-left  mb-2'>{apidata.title || "No Title Available"}</h1>
                                                    <div className=" mx-auto ">
                                                        <div className="flex flex-wrap items-center gap-4 text-gray-500 mb-3 text-lg">
                                                            {
                                                                apidata?.blog_date &&
                                                                <div className="flex items-center gap-2">
                                                                    <MdOutlineCalendarMonth className="w-6 h-6" />
                                                                    <span>Published: {apidata?.blog_date}</span>
                                                                </div>
                                                            }
                                                            <div className="flex items-center gap-2">
                                                                <CiClock2 className="w-6 h-6" />
                                                                {
                                                                    apidata?.reading_time > 0 &&
                                                                    <span>{apidata?.reading_time} min.read</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            apidata?.blog_author?.name &&
                                                            <div className="flex items-center gap-3 mb-6">
                                                                <div className="relative w-12 h-12 flex justify-center items-center rounded-full overflow-hidden shrink-0">
                                                                    {
                                                                        apidata?.blog_author?.profile_image ?
                                                                            <img
                                                                                src={apidata?.blog_author?.profile_image || ''}
                                                                                alt="Savannah Swanson"
                                                                                className="w-full h-full object-cover"
                                                                            /> :
                                                                            <FaUserCircle className='text-[38px] text-textGrey' />
                                                                    }
                                                                </div>
                                                                <div className="flex-1">
                                                                    <div className="flex items-center gap-2 ">
                                                                        <div className="!text-[20px] text-homeblack font-semibold m-0">
                                                                            {apidata?.blog_author?.name}
                                                                        </div>
                                                                        <MdVerified className="w-5 h-5 text-blue" />
                                                                    </div>
                                                                    <button
                                                                        onClick={() => setIsExpanded(!isExpanded)}
                                                                        className="flex items-center gap-1 text-homegrey text-md hover:text-gray-700 transition-colors"
                                                                    >
                                                                        <span> {apidata?.blog_author?.designation}</span>
                                                                        <motion.span
                                                                            animate={{ rotate: isExpanded ? 180 : 0 }}
                                                                            transition={{ duration: 0.2 }}
                                                                        >
                                                                            <FaAngleDown className="w-4 h-4" />
                                                                        </motion.span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        }
                                                        <AnimatePresence>
                                                            {isExpanded && (
                                                                <motion.div
                                                                    initial={{ height: 0, opacity: 0 }}
                                                                    animate={{ height: "auto", opacity: 1 }}
                                                                    exit={{ height: 0, opacity: 0 }}
                                                                    transition={{
                                                                        height: { duration: 0.3, ease: "easeOut" },
                                                                        opacity: { duration: 0.2, ease: "easeOut" }
                                                                    }}
                                                                    className="overflow-hidden"
                                                                > <div className="text-homegrey text-[16px] mb-5"
                                                                    dangerouslySetInnerHTML={{ __html: apidata?.blog_author?.description || 'No Description available about author' }} />
                                                                </motion.div>
                                                            )}
                                                        </AnimatePresence>
                                                    </div>
                                                    <StyledWrapper>
                                                        {parsedBody ? (
                                                            <div
                                                                className="prose text-homeblack w-[98%] lg:w-full leading-[30px] blog-img"
                                                                dangerouslySetInnerHTML={{ __html: parsedBody }}
                                                            />
                                                        ) : (
                                                            <p>Loading content...</p>
                                                        )}
                                                    </StyledWrapper>
                                                </div>
                                            </div>
                                        ) : (
                                            <p>Loading...</p>
                                        )}
                                    
                                    </div>
                                </StyledWrapper>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
            apidata?.blog_faq.length>0&&
            <Faq1 props={apidata?.blog_faq} title={apidata?.faq_title} />
            }
            <div className='mx-auto border-t border-slate-200 px-5 lg:px-0 lg:w-[95%]  py-12'>
                <p className="text-homeblack font-bold text-[36px] mb-5">More Realted Blogs:</p>
                <div className='flex flex-wrap  gap-4 lg:gap-0 lg:justify-between w-full ' >
                    {
                        apidata?.tag_blogs.map((elem: any, i: number) => (
                            <div key={i} className="relative border-[2px] border-lightblue hover:shadow-xl duration-300 sm:w-[45%] w-[95%] lg:w-[32%] xl:w-[24%] pb-2 rounded-lg">
                                <div className="bg-blue shadow absolute top-3 left-3 text-white text-[17px] font-medium rounded-lg py-1 px-4">
                                    {elem?.blog_date ? (() => {
                                        const date = new Date(elem.blog_date);
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const month = date.toLocaleString('en-US', { month: 'short' });
                                        const year = date.getFullYear();
                                        return `${day} ${month}, ${year}`;
                                    })() : ''}
                                </div>
                                <div className="text-blue font-medium px-3 py-1 w-fit absolute top-3 right-3 rounded-md bg-lightblue">
                                    <Link href={`/blog/${elem?.category?.category_slug}`}>
                                    <span>{elem?.category?.name || 'Uncategorized'}</span>
                                    </Link>{' '}
                                </div>
                                <div>
                                    <Image src={elem?.image ||''} unoptimized alt={elem?.image_alt} height={218} width={461} className="rounded-lg w-full max-h-[218px]" />
                                </div>
                            <div className="p-4 flex flex-col gap-3 justify-between">
                            <Link href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}>
                                <p className="font-bold text-homeblack text-[24px] leading-tight cursor-pointer" >
                                    {expandedTitle === i ? elem?.title : truncateText(elem?.title, 30)}
                                </p>
                            </Link>
                            <p className="text-homegrey leading-[21px] text-[18px] cursor-pointer" onClick={() => setExpandedSummary(expandedSummary === i ? null : i)}>
                                {expandedSummary === i ? elem?.summary : truncateText(elem?.summary, 60)}
                            </p>
                            <div>
                                <Link href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}>
                                    <Button content={'View'}></Button>
                                </Link>
                            </div>
                            </div>
                        </div>))}
                </div>
            </div>
        </div>
    );
};
export default Blogs;

